import { type FC } from "react";

import styled from "@emotion/styled";

import { fetchAdBlockTestFile } from "../../adblock/apiDetect/fetchAdBlockTestFile";

interface ImageProps {
    src: string;
    alt: string;
    widthPx?: number;
    heightPx?: number;
    isCircle?: boolean;
    className?: string;
    dataTestId?: string;
}

const Image: FC<ImageProps> = ({ src, alt, widthPx, heightPx, isCircle, className, dataTestId }) => {
    return (
        <Figure width={widthPx} height={heightPx} isCircle={isCircle} className={className} data-testid={dataTestId}>
            <Img src={src} alt={alt} />
        </Figure>
    );
};

const Figure = styled.figure<{ width?: number; height?: number; isCircle?: boolean }>(
    ({ width = 200, height = 200, isCircle = fetchAdBlockTestFile }) => ({
        width,
        height,
        display: "flex",
        alignItems: "center",
        margin: 0,
        ...(isCircle && {
            borderRadius: "50%",
            overflow: "hidden",
        }),
    }),
);

const Img = styled.img({
    objectFit: "fill",
    objectPosition: "center center",
    height: "100%",
    width: "100%",
});

export { Image };
